import { Directive, HostBinding, Input } from '@angular/core'
import { ButtonIconColors, ButtonIconSizes } from '../../../models/button.interfaces'

@Directive({
    selector: '[appButtonIcon]'
})
export class ButtonIconDirective {
    @Input() color: ButtonIconColors = 'primary'
    @Input() iconSize: ButtonIconSizes = 'small'
    @Input() full: boolean = false
    @Input() hoverEffect: boolean = true

    @HostBinding('class.hoverEffect') get buttonHoverEffect(): boolean {
        return this.hoverEffect
    }

    @HostBinding('class.app-button-icon-fulled') get buttonFulled(): boolean {
        return this.full
    }

    @HostBinding('class') get buttonClass(): string {
        return `app-button-icon app-button-icon-${this.color} app-button-icon-${this.iconSize}`
    }
}
